import React from 'react';
import { FaSearch } from 'react-icons/fa';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  placeholder?: string; 
}

const SearchBar: React.FC<SearchBarProps> = ({ searchQuery, onSearchChange, placeholder = "Search..." }) => {
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  return (
    <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full">
      <FaSearch className="mr-2 text-gray-600" />
      <input
        type="text"
        placeholder={placeholder}
        className="bg-transparent outline-none"
        value={searchQuery}
        onChange={handleSearch}
      />
    </div>
  );
};

export default SearchBar;
